import {AppConfig, EnvType} from "../../appConfig";

export const GetAppointmentHost = () => {
    if (AppConfig.envType === EnvType.dev) {
        return "https://doctor.iclinichealth.dev"
    } else if (AppConfig.envType === EnvType.uat) {
        return "https://doctor.iclinichealth.net"
    }
    return "https://doctor.iclinichealth.com"
}

export enum ApiService {
    patientCare = "patientcare/",
    patientCareUAT = "patientcareuat/",
}

enum APIBaseUrl {
    dev = "https://api-app.iclinichealth.dev/",
    uat = "https://api-app.iclinichealth.net/",
    pro = "https://api-app.iclinichealth.com/",
}

export const GetAPIHost = () => {
    if (AppConfig.envType === EnvType.dev) {
        return APIBaseUrl.dev
    } else if (AppConfig.envType === EnvType.uat) {
        return APIBaseUrl.uat
    }
    return APIBaseUrl.pro
}

export const GetAPIBaseURLByService = (apiService: string = ApiService.patientCare) => {
    let host = window.location.href.includes("localhost") ? "" : GetAPIHost();
    return host + apiService
}

export enum ApiCampaign {
    queryCampaignDetail = "Campaign/QueryCampaignDetail",
    queryCampaignWeb = "Campaign/QueryCampaignWeb",
    getPatientsByGroup = "Campaign/GetPatientsByGroup",
    getPatientGroups = "Campaign/GetPatientGroups",
    getAppointmentType = "Campaign/GetAppointmentTypes",
    getPatientInsurances = "Campaign/GetPatientInsurances",
    getIcdCodes = "Campaign/GetIcdCodes",
    getCptCodes = "Campaign/GetCptCodes",
    getPatientsByFilter = "Campaign/GetPatientsByFilter",
    savePatientGroup = "Campaign/SavePatientGroup",
    saveCampaign = "Campaign/SaveCampaign",
    sendCampaignTestMessage = "Campaign/SendCampaignTestMessage",
    saveMessageTemplate = "Campaign/SaveMessageTemplate",
    getMessageTemplates = "Campaign/GetMessageTemplates",
    getFileByCampaign = "Campaign/GetFileByCampaign",
    getFileByAutoCampaign = "Campaign/GetFileByAutoCampaign",
    excludeGroupPatients = "Campaign/ExcludeGroupPatients",
    deletePatientGroup = "Campaign/DeletePatientGroup",
    getIcdCptTemplates = "Campaign/GetIcdCptTemplates",
    getTemplateCodes = "Campaign/GetTemplateCodes",
    updateCampaign = "Campaign/UpdateCampaign",
    updateAutoCampaign = "Campaign/UpdateAutoCampaign",
    queryAutoCampaignDetail = "Campaign/QueryAutoCampaignDetail",
    changeAutoCampaignStatus = "Campaign/ChangeAutoCampaignStatus",
    changeRegularCampaignStatus = "Campaign/ChangeCampaignStatus",
    getAllPatients = "Campaign/GetPatientsByQuery01",
    exportPatients = "Campaign/GetFileByPEQuery1",
    isDoctorLinkAvailable = "Campaign/IsDoctorLinkAvailable",
}

export enum Dashboard {
    getDashboardMenuData = "Dashboard/GetDashboardMenuData",
    getAppointmentReminderDashboardData = "Dashboard/GetAppointmentReminderDashboardData",
    getAppointmentNoShowCount = "Dashboard/GetAppointmentNoShowsCount",
    getAppointmentReminderCount = "Dashboard/GetAppointmentReminderCount",
}

export enum ApiLogIn {
    updateTokenToCookie = "Login/UpdateTokenToCookie",
    getCurrentProfileInfo = "Login/GetCurrentProfileInfo"
}
